import React from 'react';
import { PropTypes } from 'prop-types';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import BatchFilesButton from 'components/Common/Buttons/BatchFilesButton';
import BatchFileFormsButton from 'components/Common/Buttons/BatchFileFormsButton';
import BatchStatus from 'common/Batches/BatchStatus';

// eslint-disable-next-line import/prefer-default-export
export const BatchActionsCellRenderer = ({
  value: id,
  data: batch,
  context: {
    settings,
    permissions,
    deleteBatchCallback,
    completeBatchCallback
  }
}) => (
  <div className="form-action-btn-group">
    { batch.id && batch.numberOfFiles != null && batch.numberOfFiles > 0 && <BatchFilesButton
      batchId={ batch.id }
      content={ <span className="icon icon-photo" /> }
      className="btn btn-sm"
      title="View Files"
    /> }

    { batch.id && batch.numberOfForms != null && batch.numberOfForms > 0 && <BatchFileFormsButton
      batchId={ batch.id }
      content={ <span className="icon icon-copy" /> }
      className="btn btn-sm"
      title="View All Forms"
    /> }

    { settings && batch.id && batch.id !== '' && batch.numberOfUnassignedForms === 0
    && AccessControl.hasPermission(permissions, [ActivityPerms.fwfBatchReviewer])
    && batch.status === BatchStatus.Processed
    && <button
      className="btn btn-sm"
      onClick={ () => completeBatchCallback(batch) }
      type="button"
      title="Complete Batch"
    >
      <span className="icon icon-share" />
    </button> }

    { settings && batch.id && batch.id !== '' && batch.numberOfUnassignedForms > 0
    && AccessControl.hasPermission(permissions, [ActivityPerms.fwfBatchReviewer])
    && batch.status === BatchStatus.Processed
    && <BatchFileFormsButton
      batchId={ batch.id }
      content={ <span className="icon icon-flag" /> }
      className="btn btn-sm"
      title={ `Unable to Complete - ${ batch.numberOfUnassignedForms } Unassigned forms` }
    /> }

    { AccessControl.hasPermission(permissions, [ActivityPerms.fwfBatchReviewer])
    && batch.status >= BatchStatus.Processed && batch.status !== BatchStatus.Completed
    && <button
      className="btn btn-sm btn-danger"
      onClick={ () => deleteBatchCallback(batch) }
      type="button"
      title="Delete Batch"
    >
      <span className="icon icon-delete" />
    </button> }
  </div>
);

BatchActionsCellRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    batchType: PropTypes.string,
    isOnlineForm: PropTypes.bool,
    numberOfFiles: PropTypes.number,
    numberOfForms: PropTypes.number,
    numberOfUnassignedForms: PropTypes.number,
    status: PropTypes.number
  }).isRequired,
  context: PropTypes.shape({
    settings: PropTypes.shape(),
    permissions: PropTypes.arrayOf(PropTypes.string),
    editLegalEntityCallback: PropTypes.func,
    completeBatchCallback: PropTypes.func,
    editCustomerLegalEntitiesCallback: PropTypes.func,
    deleteBatchCallback: PropTypes.func
  })
};

BatchActionsCellRenderer.defaultProps = {
  context: {}
};
